// STOMP でストリーミング配信されるトークンのペイロード（サーバの AiAgentTokenBody に対応）。
// 本文もツール呼び出しも同一トピック・同一の index 連番で届くため、並べ替えれば送出順が復元できる。
export type TokenStreamedPayload = {
  type?: string
  text?: string | null
  toolName?: string | null
  toolInput?: Record<string, string> | null
  index: number
}

// アシスタント応答の構成要素。ツール呼び出しをはさむと本文が複数のセグメントに分かれる。
// toolInput はツールに渡された引数（キー -> 表示用文字列）で、エージェントが指定した順序を保つ。
export type MessageSegment =
  | { kind: 'text'; text: string }
  | { kind: 'tool'; toolName: string; toolInput: Record<string, string> }

const TYPE_TOOL_START = 'tool_start'

// 単一のテキストからセグメント列を作る（あいさつ・ユーザー入力・エラー文言用）。
export const toTextSegments = (text: string): MessageSegment[] =>
  text ? [{ kind: 'text', text }] : []

// マークダウン解釈をしない箇所（ユーザー入力・エラー）で本文を取り出す。
export const segmentsToText = (segments: MessageSegment[]): string =>
  segments
    .map(segment => (segment.kind === 'text' ? segment.text : ''))
    .join('')

/**
 * 受信したトークンを index 順に並べ直し、表示単位のセグメント列へ組み立てる。
 *
 * 連続するテキストは 1 つにまとめ、ツール呼び出しでセグメントを区切る。ツールをはさんだ前後の本文は
 * サーバ側でも別の content block なので、ここで分けることで別々の段落として描画できる。
 * type を持たないペイロード（ツールイベント導入前のサーバ）はテキストとして扱う。
 */
export const combineTokenChunks = (
  chunks: TokenStreamedPayload[]
): MessageSegment[] => {
  const segments: MessageSegment[] = []
  const sorted = [...chunks].sort((a, b) => a.index - b.index)
  sorted.forEach(chunk => {
    if (chunk.type === TYPE_TOOL_START) {
      if (chunk.toolName) {
        segments.push({
          kind: 'tool',
          toolName: chunk.toolName,
          toolInput: chunk.toolInput ?? {},
        })
      }
      return
    }
    const text = chunk.text ?? ''
    if (!text) {
      return
    }
    const last = segments[segments.length - 1]
    if (last?.kind === 'text') {
      segments[segments.length - 1] = { kind: 'text', text: last.text + text }
      return
    }
    segments.push({ kind: 'text', text })
  })
  return segments
}
